<template>
  <div class="order-product-box">
    <el-form ref="form" :rules="rules" :model="form"
             onsubmit="return false" label-width="130px">
      <el-form-item label="货品" prop="goodsId">
        <el-select placeholder="请输入名称搜索货品" v-model="form.opId" filterable remote clearable
                   :remote-method="queryOtherDhsGoods" popperClass="custom-select"
                   @click.native.once="queryOtherDhsGoods('')" @change="goodsChange">
          <el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in manageGoods">
            <div>
              <span class="pull-left">{{ item.name }}</span>
            </div>
            <core-goods-field :optionItem="item" class="clearfix"/>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="批号" prop="batchNumberId" v-if="isSaleReturn">
        <el-select :remoteMethod="queryGoodsNumber('form.goodsId')" clearable filterable
                   placeholder="请输入批号名称搜索批号" @change="batchNumberIdChange"
                   remote v-model="form.batchNumberId">
          <el-option :key="item.id" :label="item.batchNumber" :value="item.id"
                     v-for="item in curGoodsBatchNumberList"/>
        </el-select>
      </el-form-item>
      <el-row>
        <el-col :span="12" v-if="!isShowBatchNumber">
          <el-form-item label="货品数量" class="productItem-info" prop="amount">
            <oms-input type="number" v-model.number="form.amount" :min="0">
              <template slot="append">
                <dict :dict-group="'measurementUnit'" :dict-key="form.measurementUnit"></dict>
              </template>
            </oms-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单价" class="productItem-info" prop="unitPrice">
            <oms-input type="text" placeholder="请输入单价" v-model="form.unitPrice" @blur="formatPrice">
              <template slot="prepend">¥</template>
            </oms-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="product-info-fix clearfix" v-if="detail.id">
      <goods-info-part :detail="detail"/>
    </div>
    <batch-number ref="batchNumber" :baseForm="baseForm" :form="form" :edited="edited" :order="order"
                  v-if="isShowBatchNumber"/>
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMixin';
  import orderMixin from '@/mixins/orderMixin';
  import utils from '@/tools/utils';
  import BatchNumber from './batchNumber';
  import saleReturnbatchNumber from '@/components/order/form/goods/saleReturnbatchNumber.vue';

  export default {
    props: {
      order: Object,
      selectGoodsList: Array,
      baseForm: Object
    },
    mixins: [MethodsMix, orderMixin],
    components: {BatchNumber, saleReturnbatchNumber},
    data() {
      return {
        form: {
          opId: '',
          goodsId: '',
          amount: '',
          unitPrice: '',
          goodsName: '',
          measurementUnit: '',
          specifications: '',
          code: '',
          batchNumberId: ''
        },
        detail: {},
        rules: {
          goodsId: [{required: true, message: '请选择货品', trigger: 'change'}],
          batchNumberId: [
            {required: true, message: '请选择批号', trigger: 'change'}
          ],
          amount: [
            {required: true, message: '请输入货品数量', trigger: 'blur'},
            {type: 'number', min: 0, message: '货品数量不能为负数', trigger: 'blur'}
          ],
          unitPrice: [{required: true, message: '请输入单价', trigger: 'blur'}],
        },
        pickerOptions: {
          disabledDate: time => {
            return time.getTime() < this.$moment().subtract(1, 'days');
          }
        },
        edited: false // 编辑标志
      };
    },
    computed: {
      isShowBatchNumber() {
        // 出库订单或者销售退货，才需要选择批号信息
        return !this.isInOrder;
      },
      isSaleReturn() {
        return this.baseForm.bizType === '1-1';
      },
      curGoodsBatchNumberList() {
        return this.goodsBatchNumberList.filter(f => this.selectGoodsList.every(s => s.batchNumberId !== f.id));
      }
    },
    methods: {
      queryOtherDhsGoods(query) {
        if (!this.baseForm.bizType) {
          this.$notify.info('请填写基本信息');
          this.resetForm();
          return;
        }
        let params = {
          keyWord: query,
          deleteFlag: false,
          auditStatus: '1',
          orgId: this.$store.state.user.userCompanyAddress
        };

        // 根据订单货品类型查货品
        switch (this.baseForm.goodsType) {
          case 0:
          case 1:
            params.typeIdList = ['1', '2'];
            break;
          case 2:
            params.typeIdList = ['3', '4'];
            break;
          case 3:
            params.typeIdList = ['7', '8'];
            break;
          case 9:
            params.typeIdList = ['5', '6'];
            break;
        }

        this.queryManageGoods(params).then(() => {
          // this.manageGoods.forEach(i => {
          //   i.id = i.goodsId;
          // });
          // 销售退货不过滤货品
          if (this.isSaleReturn) return;
          this.manageGoods = this.manageGoods.filter(f => this.selectGoodsList.every(s => s.goodsId !== f.goodsId));
        });
      },
      goodsChange(val) {
        this.resetForm();
        if (!val) return;
        this.form.opId = val;
        let item = this.manageGoods.find(f => f.id === val);
        if (!item) return;
        this.form.unitPrice = (item.unitPrice || 0.00) + '';
        this.form.goodsId = item.goodsId;
        this.form.goodsName = item.name;
        this.form.measurementUnit = item.measurementUnit;
        this.form.specifications = item.specifications;
        this.form.code = item.code;
        this.form.smallPacking = item.smallPacking;
        this.form.factoryName = item.factoryName;
        if (item.ownerCode) {
          this.form.goodsExternalCode = item.ownerCode;
        }
        this.queryGoodsNumber('form.goodsId')();
        this.detail = item;
      },
      batchNumberIdChange(val) {
        this.form.batchNumber = '';
        this.form.expirationDate = '';
        if (!val) return;
        let item = this.goodsBatchNumberList.find(f => f.id === val);
        if (!item) return;
        this.form.batchNumber = item.batchNumber;
        this.form.expirationDate = item.expirationDate;
      },
      changeNumber() {
        this.form.amount = this.changeTotalNumber(this.form.amount, this.detail.smallPacking);
      },
      formatPrice: function () {// 格式化单价，保留两位小数
        this.form.unitPrice = utils.autoformatDecimalPoint(this.form.unitPrice);
      },
      resetForm() {
        this.form = {
          opId: '',
          goodsId: '',
          batchNumberId: '',
          amount: '',
          unitPrice: '',
          goodsName: '',
          measurementUnit: '',
          specifications: '',
          code: ''
        };
        this.detail = {};
        this.edited = false;
        this.goodsBatchNumberList = [];
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
      editForm(item) {
        this.edited = true;
        this.form = item;
        this.form.unitPrice += '';
        this.form.opId = Math.random();
        let oldGoods = {
          id: this.form.opId,
          goodsId: item.goodsId,
          name: item.goodsName,
          code: item.code,
          specifications: item.specifications,
          smallPacking: item.smallPacking,
          factoryName: item.factoryName,
          ownerCode: item.goodsExternalCode
        };
        this.manageGoods = [oldGoods];
        this.goodsBatchNumberList = [{
          id: item.batchNumberId,
          batchNumber: item.batchNumber
        }];
        // 回填
        this.queryManageGoods(item.goodsName).then(res => {
          let goods = this.manageGoods.find(f => f.goodsId === item.goodsId && f.ownerCode === item.goodsExternalCode);
          if (!this.isSaleReturn) {
            this.manageGoods = this.manageGoods.filter(f => this.selectGoodsList.every(s => s.goodsId !== f.goodsId));
          }
          if (!goods) {
            this.manageGoods.push(oldGoods);
            return;
          }
          this.form.opId = goods.id;
          this.detail = goods;
        });
        this.queryGoodsNumber('form.goodsId')(item.batchNumber);
      },
      getBatchNumberList() {
        return this.$refs.batchNumber.batchNumbers.filter(f => f.isChecked);
      }
    }
  };
</script>
